class CnRCollectionFilter {
    constructor(groups,filters,labels=[]) {
        this.active_filters = groups.reduce((a,b)=>{
          a[b]=[];
          return a;
        },
        {});
        this.preferred_orders = {
          "Size":["Small","Medium","Large","XL"]
        };
        this.filter_groups = groups.map(entry=>{
            return {
                id:entry,
                label:entry,
                filters:[],
            }
        });
        filters.forEach(pair=>{
            let kp = pair.split("|");
            let ind = this.filter_groups.findIndex(el=>el.id==kp[0]);
            if (kp[0]=="Size") {
                kp[1] = kp[1].split(" ")[0];
              }
            if (ind>=0) {
              if (!this.filter_groups[ind].filters.includes(kp[1])) {
                this.filter_groups[ind].filters.push(kp[1])
              }
            }
        });
      labels.forEach((value,index)=>{
        if (this.filter_groups[index]) {
          this.filter_groups[index].label=value;
        }
      })
    }
    initialize() {
      this.render();
      document.querySelectorAll('.filter-link').forEach(link=>{

        link.addEventListener("click",(e)=>{
          e.preventDefault();
          
          // Get filter type and value from data attributes
          var filterType = link.getAttribute('data-filter-type');
          var filterValue = link.getAttribute('data-filter-value');
    
          if (this.active_filters[filterType]) {
            if (this.active_filters[filterType].includes(filterValue)) {
              this.active_filters[filterType] = this.active_filters[filterType].filter(item=>item!=filterValue);
              link.classList.remove("active");
            } else {
              this.active_filters[filterType].push(filterValue);
            link.classList.add("active");
            }
          }
          this.applyFilters();
          });
      });
      document.querySelector("#cr-clear-filters").addEventListener("click",event=>{
        event.preventDefault();
        this.clearFilters();
      })

      document.addEventListener("DOMContentLoaded",()=>{
        this.collections = Array.from(document.querySelectorAll(".collection-ident")).map(item=>item.getAttribute("data-collection"));
        let urlparams="";
        if (location.href.indexOf("#")>=0) {
           urlparams = location.href.split("#").reverse()[0].split("?")[0];
        }
        urlparams.split("&").forEach(kvp=>{
         let parts = decodeURI(kvp).split("=");
          try {
            this.active_filters[parts[0]] = parts[1].split(",");
          }  catch(e){}
        });
        Object.keys(this.active_filters).forEach(type=>{
          this.active_filters[type].forEach(item=>document.querySelector(`[data-filter-type="${type}"][data-filter-value="${item}"]`).classList.add("active"));
        });
        this.applyFilters();
      });
    }
    parseFilters(arr) {
       
      
    }
    applyFilters() {
      let filterCount = Object.values(this.active_filters).reduce((a, b) => a + b.length, 0);
      let urltag = location.href.split("#")[0];
  
      if (filterCount < 1) {
          document.querySelectorAll("[data-product-card]").forEach(card => {
              if (card.hasAttribute("data-is-default")) {
                  card.removeAttribute("hidden");
              } else {
                  card.setAttribute("hidden", "");
              }
          });
      } else {
          document.querySelectorAll("[data-product-card]").forEach(card => {
              let matches = [];
  
              this.filter_groups.forEach(group => {
                  let active_filters = this.active_filters[group.id] || [];
  
                  if (active_filters.length > 0) {
                      let product_filters = card.getAttribute(`data-filters-${group.id}`)?.split(",") || [];
  
                      let hasMatch = active_filters.some(filter => product_filters.includes(filter));
                      
                      if (hasMatch) {
                          matches.push(true);
                      }
                  }
              });
  
              if (matches.length > 0 && matches.includes(true)) {
                  card.removeAttribute("hidden");
              } else {
                  card.setAttribute("hidden", "");
              }
          });
  
          urltag = "#" + Object.keys(this.active_filters)
              .map(k => this.active_filters[k].length > 0 ? encodeURI(`${k}=${this.active_filters[k].join(",")}`) : null)
              .filter(a => a != null)
              .join("&");
      }
  
      let filtered = 0;
      this.collections.forEach(collection => {
          let all = document.querySelectorAll(`[data-product-card][data-collection="${collection}"]`).length;
          let hidden = document.querySelectorAll(`[data-product-card][data-collection="${collection}"][hidden]`).length;
          filtered += (all - hidden);
  
          if (all - hidden < 1) {
              document.querySelector(`.collection-card[data-collection="${collection}"]`).setAttribute("hidden", "");
          } else {
              document.querySelector(`.collection-card[data-collection="${collection}"]`).removeAttribute("hidden");
          }
      });
  
      if (filtered < 1) {
          document.querySelector(".no_results_notification").removeAttribute("hidden");
          document.querySelector(".no_results_notification").scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      } else {
          document.querySelector(".no_results_notification").setAttribute("hidden", "");
      }
  
      history.replaceState(null, null, urltag);
  }  
  render() {
    let container = document.querySelector(".cr-filter-groups");
    var codelist = '';
    container.innerHTML = "";
    this.filter_groups.forEach(group=>{
      if (group.filters.length<1) {
        return;
      }
      if (this.preferred_orders[group.id]) {
        let unordered_filters = group.filters.filter(oi=>!this.preferred_orders[group.id].includes(oi));
        group.filters = this.preferred_orders[group.id].filter(oi=>group.filters.includes(oi));
        group.filters = group.filters.concat(unordered_filters)
      }
      codelist+=`
        <div class="cr-filter-group-container">
        <h3 id="filter-group-${group.id}">${group.label}</h3>
        <ul class="cr-filter-list">
      `;
      group.filters.forEach(filter=>{
        let label = filter;
        let value = filter;
        if (filter.indexOf(":")>0) {
          label = filter.split(":")[1];
          value = filter.split(":")[0];
        }
        codelist+=`<li class="filter-item">
        <a href="/collections" class="filter-link generated" data-filter-type="${group.id}" data-filter-value='${value}'>${ label}</a>
        </li>`;
      });
      codelist+=`</ul></div>`;
    });
    container.innerHTML=codelist;
    container.innerHTML+= `<br><a class="clear-all d-none d-lg-block" id="cr-clear-filters" href="#">Clear Filters</a>`;
  }
  clearFilters() {
    Object.keys(this.active_filters).forEach(k=>this.active_filters[k]=[]);
    document.querySelectorAll(".filter-link").forEach(el=>el.classList.remove("active"));
    this.applyFilters();
  }
}